import { Dispatch } from 'react';
import Area from 'models/Area';
import Category from 'models/Category';
import Poi from 'models/Poi';
import { SearchFilter, SearchSort } from 'contexts/SearchHelpers';
import { ApiListResponse } from 'data/types';
export enum SearchActionType {
    Init = 'INITIALISE',
    SetArea = 'SET_AREA',
    SetCategory = 'SET_CATEGORY',
    SetUrl = 'SET_URL',
    SetPage = 'SET_PAGE',
    SetAllFilters = 'SET_AVAILABLE_FILTERS',
    SetFilters = 'SET_FILTERS',
    SetMapView = 'SET_MAP_VIEW',
    SetAllSorts = 'SET_AVAILABLE_SORTS',
    ResetParams = 'RESET_PARAMS',
    SetLoading = 'SET_LOADING',
    SetMapResults = 'SET_MAP_RESULTS',
    SetResults = 'SET_RESULTS',
    SetSortDirection = 'SET_SORT_DIRECTION',
    SetSort = 'SET_SORT'
}

export type SearchAction = {
    type: SearchActionType;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
};

const initialise = (dispatch: Dispatch<SearchAction>) => {
    dispatch({ type: SearchActionType.Init });
};

const setPage = (dispatch: Dispatch<SearchAction>, currentPage: number) => {
    dispatch({ type: SearchActionType.SetPage, currentPage });
};

const setArea = (dispatch: Dispatch<SearchAction>, area: Area) => {
    dispatch({ type: SearchActionType.SetArea, area });
};
const setCategory = (dispatch: Dispatch<SearchAction>, category: Category) => {
    dispatch({ type: SearchActionType.SetCategory, category });
};
const setAvailableFilters = (dispatch: Dispatch<SearchAction>, filters: SearchFilter[]) => {
    dispatch({ type: SearchActionType.SetAllFilters, filters });
};

const setFilters = (dispatch: Dispatch<SearchAction>, filters: SearchFilter[]) => {
    dispatch({ type: SearchActionType.SetFilters, filters });
};

const setMapView = (dispatch: Dispatch<SearchAction>, mapView: boolean) => {
    dispatch({ type: SearchActionType.SetMapView, mapView });
};

const setAvailableSorts = (dispatch: Dispatch<SearchAction>, sorts: SearchSort[]) => {
    dispatch({ type: SearchActionType.SetAllSorts, sorts });
};
const setSort = (dispatch: Dispatch<SearchAction>, sort: SearchSort) => {
    dispatch({ type: SearchActionType.SetSort, sort });
};

const setSortDirection = (dispatch: Dispatch<SearchAction>, direction: 'ASC' | 'DESC') => {
    dispatch({ type: SearchActionType.SetSortDirection, direction });
};

const setLoading = (dispatch: Dispatch<SearchAction>, loading: boolean) => {
    dispatch({ type: SearchActionType.SetLoading, loading });
};

const setResults = (dispatch: Dispatch<SearchAction>, results: ApiListResponse<Poi>) => {
    dispatch({ type: SearchActionType.SetResults, results });
};

const setMapResults = (dispatch: Dispatch<SearchAction>, results: ApiListResponse<Poi>) => {
    dispatch({ type: SearchActionType.SetMapResults, results });
};

const resetParameters = (dispatch: Dispatch<SearchAction>) => {
    dispatch({ type: SearchActionType.ResetParams });
};

const setUrl = (dispatch: Dispatch<SearchAction>, url: string) => {
    dispatch({ type: SearchActionType.SetUrl, url });
};

export {
    initialise,
    setPage,
    setArea,
    setCategory,
    setAvailableFilters,
    setFilters,
    setMapView,
    setAvailableSorts,
    setSort,
    setSortDirection,
    setLoading,
    setResults,
    setMapResults,
    resetParameters,
    setUrl
};
